import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/Badge';
import type { BadgeVariant } from '@/components/ui/Badge';
import { TOURNAMENT_STATUS_BADGE_TONE } from '@/components/ui/Badge/tones';
import type { TournamentStatus } from '@/constants';

export interface StatusBadgeProps {
  status: TournamentStatus;
  variant?: BadgeVariant;
  className?: string;
}

/** Tournament list status (active / upcoming / closed) as a `Badge`. */
export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, variant, className }) => {
  const { t } = useTranslation('tournament');

  return (
    <Badge tone={TOURNAMENT_STATUS_BADGE_TONE[status]} variant={variant} className={className}>
      {t(`tournament:list.status.${status}`)}
    </Badge>
  );
};

export default StatusBadge;
